import {Browser} from "./Browser";
import {Display} from "./Display";

export class Metrics
{
    static async init()
    {
        Metrics.navigator = await Metrics.get_navigatorInfo();
        Metrics.url = document.location.pathname;

        // determine if page is an article
        const pathParts = Metrics.url.replace(/^\//, '').split('/');

        Metrics.type = '';
        if(!!(pathParts[0] && pathParts[0] === 'my-books' && pathParts.length === 3))
        {
            Metrics.type = 'book';
        }

        Metrics.log_visit();
        Metrics.reset();
    }

    static gather_info()
    {
        return {
            os: Browser.os,
            engine: Browser.engine,
            version: Browser.version,
            x: Display.x,
            y: Display.y
        }
    }

    static async get_navigatorInfo()
    {
        let permissions;

        // WebGL check
        let graphics = { vendor: 'unknown', renderer: 'unknown' };
        try
        {
            if(typeof OffscreenCanvas !== 'undefined')
            {
                const canvas = new OffscreenCanvas(1,1);
                const gl = canvas.getContext('webgl');
                if(gl)
                {
                    let gpuRenderer = gl.getParameter(gl.RENDERER);

                    if(!gpuRenderer ||
                        gpuRenderer.includes("WebKit") ||
                        gpuRenderer.includes("WebGL") ||
                        gpuRenderer === "Mozilla")
                    {
                        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
                        if(debugInfo)
                        {
                            graphics.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
                            graphics.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
                        }
                    }
                    else
                    {
                        graphics.vendor = gl.getParameter(gl.VENDOR);
                        graphics.renderer = gl.getParameter(gl.RENDERER);
                    }
                }
            }
        }
        catch(e)
        {
            graphics.error = "webgl-blocked";
        }

        // permissions check
        try
        {
            const permissionStatus = await navigator.permissions.query({ name: 'notifications' });
            permissions = (Notification.permission === 'denied' && permissionStatus.state === 'prompt')
                ? 'mismatch'
                : 'match';
        }
        catch(e)
        {
            // Fallback falls permissions API nicht verfügbar ist
            permissions = 'unavailable';
        }

        // noinspection JSDeprecatedSymbols
        return {
            webdriver: navigator.webdriver,
            lang: {
                language: navigator.language,
                languages: navigator.languages ? navigator.languages : null,
            },
            permissions: permissions,
            userAgent: navigator.userAgent,
            chrome: !!window.chrome,
            platform: navigator.platform,
            webGl: graphics
        };
    }

    static log_file(fileId)
    {
        if(document.body.dataset.ise !== 'on' &&
            !navigator.userAgent.match(/(bot|headlesschrome|spider)/i))
        {
            const data = {
                type: 'file',
                browser: Metrics.gather_info(),
                fileId: fileId
            };
            Metrics.send_data(data);
        }
    }

    static log_visit()
    {
        if(document.body.dataset.ise !== 'on' &&
          !navigator.userAgent.match(/(bot|headlesschrome|spider)/i))
        {
            const data = {
                type: 'log',
                uniqueVisitor: false,
                uniquePageVisitor: false,
                browser: Metrics.gather_info(),
                url: document.location.pathname
            };

            if(!sessionStorage.getItem('visit'))
            {
                sessionStorage.setItem('visit', '1');
                data.uniqueVisitor = true;
                data.referrer = document.referrer;
            }

            if(!sessionStorage.getItem(Metrics.url))
            {
                sessionStorage.setItem(Metrics.url, '1');
                data.uniquePageVisitor = true;
            }

            if(data.uniqueVisitor || data.uniquePageVisitor)
            {
                Metrics.send_data(data);
            }
        }
    }

    static reset()
    {
        Metrics.time = Date.now();
    }

    static page_unload()
    {
        if(Metrics.type === 'book' &&
          !navigator.userAgent.match(/(bot|headlesschrome|spider)/i) &&
           document.body.dataset.ise !== 'on')
        {
            const duration = Math.round((Date.now() - Metrics.time) / 1000);

            if(!isNaN(duration) && duration > 0)
            {
                const data = {
                    type: Metrics.type,
                    duration: Math.round((Date.now() - Metrics.time) / 1000),
                    browser: Metrics.gather_info(),
                    url: document.location.pathname
                }
                Metrics.send_data(data);
            }
        }
    }

    static send_data(data)
    {
        data.f = 'metrics';
        data.navigator = Metrics.navigator;
        const fd = new FormData();
        fd.append('json', JSON.stringify(data));
        navigator.sendBeacon('/index.php', fd);
    }
}
